import { getPlatformLimit } from '@/constants/platformLimits';

export interface PlatformConfig {
  key: string;
  displayName: string;
  avatarColor: string; // Tailwind gradient/bg class for the preview avatar
  hashtagColor: string; // Tailwind text class for hashtags
}

export const PLATFORM_CONFIG: Record<string, PlatformConfig> = {
  linkedin: {
    key: 'linkedin',
    displayName: 'LinkedIn',
    avatarColor: 'bg-gradient-to-br from-blue-500 to-blue-600',
    hashtagColor: 'text-[#0073B1]',
  },
  twitter: {
    key: 'twitter',
    displayName: 'Twitter/X',
    avatarColor: 'bg-black',
    hashtagColor: 'text-[#1D9BF0]',
  },
  instagram: {
    key: 'instagram',
    displayName: 'Instagram',
    avatarColor: 'bg-gradient-to-br from-purple-500 via-pink-500 to-orange-400',
    hashtagColor: 'text-[#0095F6]',
  },
  facebook: {
    key: 'facebook',
    displayName: 'Facebook',
    avatarColor: 'bg-gradient-to-br from-blue-500 to-blue-700',
    hashtagColor: 'text-[#1877F2]',
  },
  tiktok: {
    key: 'tiktok',
    displayName: 'TikTok',
    avatarColor: 'bg-gray-800',
    hashtagColor: 'text-blue-400',
  },
  threads: {
    key: 'threads',
    displayName: 'Threads',
    avatarColor: 'bg-gradient-to-br from-gray-800 to-black',
    hashtagColor: 'text-blue-500',
  },
  bluesky: {
    key: 'bluesky',
    displayName: 'Bluesky',
    avatarColor: 'bg-[#0085FF]',
    hashtagColor: 'text-[#0085FF]',
  },
  pinterest: {
    key: 'pinterest',
    displayName: 'Pinterest',
    avatarColor: 'bg-gradient-to-br from-red-500 to-red-600',
    hashtagColor: 'text-[#E60023]',
  },
  youtube: {
    key: 'youtube',
    displayName: 'YouTube',
    avatarColor: 'bg-[#FF0000]',
    hashtagColor: 'text-[#FF0000]',
  },
  google_my_business: {
    key: 'google_my_business',
    displayName: 'Google Business',
    avatarColor: 'bg-[#4285F4]',
    hashtagColor: 'text-[#4285F4]',
  },
};

/**
 * Truncate caption based on platform character limits
 */
export function truncateForPlatform(caption: string, platform: string): string {
  const limit = getPlatformLimit(platform, 'characters');
  if (caption.length <= limit) return caption;
  return caption.slice(0, limit - 3) + '...';
}
